// import React, { useState } from "react";
// import LiveQuizzes from "./LiveQuizzes";
// import PracticeQuizzes from "./PracticeQuizzes";

// const StudentQuizDetails = () => {
//   const [activeTab, setActiveTab] = useState("live");

//   return (
//     <div className="container-fluid px-5 py-3">
//       <div className="mb-3">
//         <button
//           className={`btn me-2 ${
//             activeTab === "live" ? "btn-primary" : "btn-outline-primary"
//           }`}
//           onClick={() => setActiveTab("live")}
//         >
//           Live Quizzes
//         </button>
//         <button
//           className={`btn ${
//             activeTab === "practice" ? "btn-primary" : "btn-outline-primary"
//           }`}
//           onClick={() => setActiveTab("practice")}
//         >
//           Practice Quizzes
//         </button>
//       </div>
//       {activeTab === "live" && <LiveQuizzes />}
//       {activeTab === "practice" && <PracticeQuizzes />}
//     </div>
//   );
// };

// export default StudentQuizDetails;

import React, { useEffect, useState } from "react";
import LiveQuizzes from "./LiveQuizzes";
import { useDispatch, useSelector } from "react-redux";
import { getQuizzes } from "../SchoolQuiz/redux/thunk";

const StudentQuizDetails = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [selectedQuiz, setSelectedQuiz] = useState("");

  const { loading } = useSelector((state) => state.quiz);
  const { quizzes } = useSelector((state) => state.quizManagement);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authSlice.user);

  useEffect(() => {
    dispatch(
      getQuizzes({
        quizType: activeTab,
        schoolId: user?.admin_id ?? "",
      }),
    );
  }, [activeTab]);

  // change tab and reset the selected quiz in the same update
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedQuiz("");
  };

  return (
    <div className="container-fluid px-5 pt-0 pb-3">
      <div className="d-flex align-items-center flex-wrap gap-4 mb-3">
        <span className="fw-bold">Quiz Type:</span>

        <div className="d-flex align-items-center gap-2">
          <input
            className="form-check-input m-0"
            type="radio"
            name="quizType"
            id="liveAcademic"
            value="1"
            checked={activeTab === "1"}
            onChange={() => handleTabChange("1")}
          />
          <label htmlFor="liveAcademic" className="mb-0">
            Live Academic Quizzes
          </label>
        </div>

        <div className="d-flex align-items-center gap-2">
          <input
            className="form-check-input m-0"
            type="radio"
            name="quizType"
            id="liveThematic"
            value="3"
            checked={activeTab === "3"}
            onChange={() => handleTabChange("3")}
          />
          <label htmlFor="liveThematic" className="mb-0">
            Live Thematic Quizzes
          </label>
        </div>

        <div className="d-flex align-items-center gap-2">
          <label htmlFor="quizSelect" className="fw-bold mb-0">
            Quiz:
          </label>
          <select
            id="quizSelect"
            className="form-select py-1"
            value={selectedQuiz}
            onChange={(e) => setSelectedQuiz(e.target.value)}
            disabled={loading}
            style={{ fontSize: "0.9rem", minWidth: "250px", width: "auto" }}
          >
            <option value="">Select Quiz</option>
            {quizzes
              ?.filter((q) => q.status !== "deleted")
              .map((quiz) => (
                <option key={quiz.id} value={quiz.id}>
                  {quiz.title}
                </option>
              ))}
          </select>
        </div>
      </div>

      <LiveQuizzes quizType={activeTab} selectedQuiz={selectedQuiz} />
    </div>
  );
};

export default StudentQuizDetails;
